
import Vue, { RenderContext } from "vue";
export default Vue.extend({
  name: "UOnboarding",
  functional: true,
  props: {
    if: {
      type: Boolean,
      default: false
    }
  },
  render(h, { props, data, listeners, children, scopedSlots }: RenderContext) {
    if (props.if) {
      return h("u-onboard-screen", {
        props: data.attrs,
        on: {
          click: event => {
            const emit = listeners.click as Function;
            emit(event);
          }
        },
        scopedSlots
      });
    } else {
      return children;
    }
  }
});
